/**
 * @generated SignedSource<<427bd68f6b792d96582c89c658e47c5a>>
 * @relayHash baeadbd357501a4d3adc7c68a924b3e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aa29d7daadcf203a8564a93335ab40e1bf11e665d9566f5cda2b9b522ffddd98

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { issueNotificationsQuery } from './issueNotificationsQuery.graphql';

const node: PreloadableConcreteRequest<issueNotificationsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "aa29d7daadcf203a8564a93335ab40e1bf11e665d9566f5cda2b9b522ffddd98",
    "metadata": {},
    "name": "issueNotificationsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
